import styled from 'styled-components';

export const NoteForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  margin-bottom: 25px;
`;

export const AddNoteInput = styled.input`
  width: 400px;
  height: 25px;
`;
